import styled from "styled-components";

export const LogoBox = styled.div`
  height: 32px;
  padding-right: 18px;
  display: flex;
  justify-content: center;

  img {
    height: 100%;
  }
`;

export const HeaderTitle = styled.div`
  font-size: ${props => props.theme.fontSize.fs22};
  font-weight: bold;
  margin-left: 16px;
  padding-left: 16px;
  border-left: 2px solid rgba(168,168,168,0.5);
`;

export const HeaderMenu = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  button {
    flex: 0 0 120px;
    border: none;
    width: auto;

    &:hover, &:active {
      border: none !important;
    }

    &:not(:focus-visible) {
      outline: 0;
      border: none !important;
    }
  }

  ul.dropdown-menu:focus button.btn-dropdown {
    border: none;
  }
`;

